import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoggedInGuard } from './Helpers/Guards/loggedin.guard';
import { PaginaNaoEncontradaComponent } from './Components/pagina-nao-encontrada/pagina-nao-encontrada.component';

const appRoutes: Routes = [
  { path: '', redirectTo: 'publico', pathMatch: 'full' },
  {
    path: 'publico',
    loadChildren: () => import('./Pages/public/public.module').then(module => module.PublicModule),
  },
  {
    path: 'secure',
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./Pages/secure/secure-core.module').then(module => module.CoreModule),
  },
  {
    path: 'pagina-nao-encontrada', component: PaginaNaoEncontradaComponent
  },
  { path: '**', redirectTo: 'publico', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
